import { TEST } from "../../../data/page_types"
import check_if_user_in_dev_env from "../../Shared/methods/check_if_user_in_dev_env"

export default (store_id, store_name_id, domain) => {
  return domain || `https://${check_if_user_in_dev_env() ? `${TEST}-` : ""}stores.ulsemo.com/${store_name_id || store_id}`
}
